import { makeHandlerChainAwaitable, replaceInChain } from "@insite/client-framework/HandlerCreator";
import validateAddress, { AddressErrors } from "@insite/client-framework/Store/CommonHandlers/ValidateAddress";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import {
    chain,
    ValidateAddress,
} from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/ValidateShippingAddressForm";

replaceInChain(chain, ValidateAddress, async props => {
    // Verndale Customization: SIMGOPT-878: Added page type to check if it is CheckoutShippingPage
    const state = props.getState();
    const page = getCurrentPage(state);
    const isCheckoutShippingPage = page.type === "CheckoutShippingPage";
    // End of Verndale Customization

    const awaitableValidate = makeHandlerChainAwaitable<Parameters<typeof validateAddress>[0], AddressErrors>(
        validateAddress,
    );

    // Verndale Customization: SIMGOPT-878: Added page type to check if it is CheckoutShippingPage
    let customValidation = props.parameter.validation;
    if (isCheckoutShippingPage) {
        customValidation = {
            ...props.parameter.validation,
            firstName: {
                ...props.parameter.validation.firstName,
                isRequired: false,
                isDisabled: false,
                maxLength: props.parameter.validation.firstName?.maxLength || null,
            },
            lastName: {
                ...props.parameter.validation.lastName,
                isRequired: false,
                isDisabled: false,
                maxLength: props.parameter.validation.lastName?.maxLength || null,
            },
            email: {
                ...props.parameter.validation.email,
                isRequired: false,
                isDisabled: false,
                maxLength: props.parameter.validation.email?.maxLength || null,
            },
        };
    }
    // End of Verndale Customization

    props.formErrors = await awaitableValidate({
        address: props.parameter.address,
        validationRules: customValidation!,
        addressFieldDisplayCollection: props.parameter.fieldDisplay,
    })(props.dispatch, props.getState);
});
